<template>
  <dl ref="revealRef" :class="listClasses" data-testid="stats-block">
    <StatsItem
      v-for="(item, idx) in items"
      :key="idx"
      :raw-value="item.value"
      :label="item.label"
      :helper="item.helper"
      :tone="tone"
      :size="size"
      :duration="duration"
      :reveal="isRevealed"
    />
  </dl>
</template>

<script setup lang="ts">
/**
 * Блок ключевых метрик. Каждая метрика рендерится через
 * `StatsItem`, который владеет собственным `useCountUp` —
 * благодаря этому нет исторического ограничения `MAX = 6`.
 *
 * Триггер анимации — `useScrollReveal` (IntersectionObserver):
 * как только блок попадает во viewport, все items стартуют.
 */
import { computed } from 'vue';
import { cn } from '@/lib/cn';
import { useScrollReveal } from '@/composables/useScrollReveal';
import StatsItem from '@/components/domain/StatsItem.vue';
import type { StatsBlockItem } from '@/types/component-types';

export type { StatsBlockItem } from '@/types/component-types';

interface Props {
  items: readonly StatsBlockItem[];
  tone?: 'default' | 'inverse' | 'white';
  size?: 'default' | 'large';
  duration?: number;
}

const props = withDefaults(defineProps<Props>(), {
  tone: 'default',
  duration: 1200,
  size: 'default',
});

const { isRevealed } = useScrollReveal();

const listClasses = computed(() =>
  cn('grid gap-6 sm:grid-cols-3', props.items.length >= 4 && 'md:grid-cols-4'),
);
</script>
